

import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { deletePartner } from "../../features/admin/PartnerSlice";
import MediaModal from "../../components/admin/MediaModal";
import { toast } from "react-toastify";
import { fetchMedias } from "../../features/admin/MediaSlice";

const getUserPermissions = () => {
  const permissions = localStorage.getItem("permissions");
  return permissions
    ? JSON.parse(permissions).map((p) => p.permissionSlug)
    : [];
};

const userId = localStorage.getItem("userId");
const hasPermission = (requiredPermission) => {
  if (userId == 1) {
    return true;
  }
  const userPermissions = getUserPermissions();
  return userPermissions.includes(requiredPermission);
};

const EMPTY_IDS = [];

const Medias = ({
  isModal = false,
  pickerMode = false,
  selectedIds = EMPTY_IDS,
  excludedIds = EMPTY_IDS,
  onToggleSelect = null,
  onConfirmSelection = null,
  onClose = null,
  isSavingSelection = false,
}) => {
  const dispatch = useDispatch();
  const { medias, status, error } = useSelector((state) => state.medias);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [filtedMedias, setFiltedMedias] = useState();
  const [currentTab, setCurrentTab] = useState("image");

  const handleOpenModal = (media = null) => {
    setSelectedMedia(media);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedMedia(null);
    dispatch(fetchMedias());
  };

  const handleDelete = (id) => {
    dispatch(deletePartner(id)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        toast.success("Xóa hình ảnh thành công!");
        handleCloseModal();
      } else {
        toast.error("Đã xảy ra lỗi khi xóa hình ảnh!");
      }
    });
  };

  useEffect(() => {
    let filteredMedias = medias?.filter((media) =>
      currentTab === "image"
        ? media.imageableType === "product"
        : media.imageableType === "user" || media.imageableType === "companie"
    );

    if (pickerMode) {
      filteredMedias = filteredMedias?.filter(
        (media) =>
          media.imageType !== "video" && !excludedIds.includes(media.id)
      );
    }

    setFiltedMedias(filteredMedias);
  }, [medias, currentTab, pickerMode, excludedIds]);

  useEffect(() => {
    dispatch(fetchMedias());
  }, [dispatch]);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchMedias());
    }
  }, [status, dispatch]);

  const content = (
    <div
      className={
        isModal
          ? "bg-base-100 rounded-2xl shadow-2xl w-full max-w-7xl max-h-[90vh] flex flex-col overflow-hidden"
          : "p-6"
      }
    >
      <div
        className={
          isModal
            ? "px-6 py-5 border-b flex items-center justify-between gap-4"
            : ""
        }
      >
        <div>
          <h1 className="text-2xl font-semibold">
            {pickerMode ? "Quản lý hình ảnh" : "Quản lý hình ảnh"}
          </h1>
          {pickerMode && (
            <p className="text-sm text-gray-500 mt-1">
              Chọn hình ảnh có sẵn hoặc thêm hình ảnh mới.
            </p>
          )}
        </div>

        {isModal && (
          <button
            type="button"
            onClick={onClose}
            className="btn btn-sm btn-ghost"
            disabled={isSavingSelection}
          >
            ✕
          </button>
        )}
      </div>

      <div
        className={
          isModal
            ? "px-6 py-4 flex-1 overflow-y-auto"
            : ""
        }
      >
        <div className="flex items-center justify-between gap-4 mb-4">
          {hasPermission("MEDIA_UPLOAD") && (
            <button
              onClick={() => handleOpenModal()}
              className="btn btn-success transition-colors px-4 py-2 rounded"
              disabled={isSavingSelection}
            >
              + Thêm hình ảnh
            </button>
          )}

          {pickerMode && (
            <div className="text-sm text-gray-500">
              Đã chọn: {selectedIds.length}
            </div>
          )}
        </div>

        {!pickerMode && (
          <div className="border-b border-gray-200 mb-4">
            <nav className="-mb-px flex space-x-4">
              <button
                onClick={() => setCurrentTab("image")}
                className={`whitespace-nowrap py-4 px-1 border-b-2 ${
                  currentTab === "image"
                    ? "border-blue-500 text-blue-500"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
              >
                Hình ảnh
              </button>
              <button
                onClick={() => setCurrentTab("avatar")}
                className={`whitespace-nowrap py-4 px-1 border-b-2 ${
                  currentTab === "avatar"
                    ? "border-blue-500 text-blue-500"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
              >
                Hội viên
              </button>
            </nav>
          </div>
        )}

        {status === "loading" && !filtedMedias?.length ? (
          <div className="py-12 text-center">Đang tải hình ảnh...</div>
        ) : status === "failed" ? (
          <div className="py-12 text-center text-red-500">
            Error: {error}
          </div>
        ) : filtedMedias?.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
            {filtedMedias.map((media) => {
              const isSelected = selectedIds.includes(media.id);

              return (
                <button
                  key={media.id}
                  type="button"
                  onClick={() => {
                    if (pickerMode) {
                      onToggleSelect?.(media.id);
                    } else {
                      handleOpenModal(media);
                    }
                  }}
                  disabled={isSavingSelection}
                  className={`relative border rounded-xl overflow-hidden shadow-sm bg-base-100 text-left transition-all ${
                    pickerMode
                      ? isSelected
                        ? "ring-2 ring-blue-500 border-blue-500"
                        : "hover:border-blue-300 hover:shadow-md"
                      : "cursor-pointer hover:shadow-md"
                  }`}
                >
                  <div className="aspect-square bg-gray-50">
                    <img
                      src={media.url}
                      alt="Media"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>

                  {pickerMode && (
                    <div className="absolute top-2 right-2">
                      <input
                        type="checkbox"
                        className="checkbox checkbox-info bg-white shadow"
                        checked={isSelected}
                        onChange={() => onToggleSelect?.(media.id)}
                        onClick={(e) => e.stopPropagation()}
                        disabled={isSavingSelection}
                      />
                    </div>
                  )}
                </button>
              );
            })}
          </div>
        ) : (
          <p className="text-center text-gray-500 py-16">
            {pickerMode
              ? "Chưa có hình ảnh nào để chọn. Bấm “+ Thêm hình ảnh” để tải ảnh mới."
              : "Chưa có ảnh được tải lên"}
          </p>
        )}
      </div>

      {pickerMode && isModal && (
        <div className="px-6 py-4 border-t flex items-center justify-end gap-3 bg-base-100">
          <button
            type="button"
            onClick={onClose}
            className="btn btn-sm"
            disabled={isSavingSelection}
          >
            Hủy
          </button>
          <button
            type="button"
            onClick={onConfirmSelection}
            className="btn btn-primary btn-sm"
            disabled={selectedIds.length === 0 || isSavingSelection}
          >
            {isSavingSelection
              ? "Đang thêm..."
              : `Thêm${selectedIds.length > 0 ? ` (${selectedIds.length})` : ""}`}
          </button>
        </div>
      )}

      {isModalOpen && (
        <MediaModal
          imageableId={userId}
          imageableType={currentTab == "avatar" ? "user" : "product"}
          imageType={currentTab == "avatar" ? "avatar" : "thumbnail"}
          media={selectedMedia}
          onClose={handleCloseModal}
          onDelete={() => handleDelete(selectedMedia?.id)}
          multiImage={true}
        />
      )}
    </div>
  );

  if (isModal) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] p-4">
        {content}
      </div>
    );
  }

  return content;
};

export default Medias;
